import { render } from "./MailingList.vue?vue&type=template&id=3a2d30f9&ts=true"
import script from "./MailingList.vue?vue&type=script&lang=ts"
export * from "./MailingList.vue?vue&type=script&lang=ts"

import "./MailingList.vue?vue&type=style&index=0&id=3a2d30f9&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__